export enum ConfigInvoiceTemplate {
  LAVOIR_MODERNE = 'LAVOIR_MODERNE',
  LE_CHAT_SERVICE = 'LE_CHAT_SERVICE',
  LECLERC = 'LECLERC',
}
